import { z } from 'zod';
/** The roles that have a guide in docs/roles/. The test admin reads the CER admin guide. */
export const GuideRole = z.enum(['cer_admin', 'cer_officer', 'participant_admin', 'participant_user', 'applicant']);
/** The signed-in user's role guide, as Markdown. Only the caller's own guide is ever served. */
export const RoleGuide = z.object({
    role: GuideRole,
    title: z.string(),
    markdown: z.string(),
});
//# sourceMappingURL=help.js.map